import axios from "axios";
// import swal from 'sweetalert';
// import { useDispatch } from "react-redux";
import { LOG_APP } from "utils";
import { logoutUser } from "actions/AuthAction";
import { ADMINS_TOKEN } from "utils";

export const dateTime = (waktu) => {
  const hari = {
    0: "Minggu",
    1: "Senin",
    2: "Selasa",
    3: "Rabu",
    4: "Kamis",
    5: "Jumat",
    6: "Sabtu",
  };

  const bulan = {
    0: "Januari",
    1: "Februari",
    2: "Maret",
    3: "April",
    4: "Mei",
    5: "Juni",
    6: "Juli",
    7: "Agustus",
    8: "September",
    9: "Oktober",
    10: "November",
    11: "Desember",
  };

  const bulan2 = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "Mei",
    5: "Jun",
    6: "Jul",
    7: "Agu",
    8: "Sep",
    9: "Okt",
    10: "Nov",
    11: "Des",
  };
  var tanggal = new Date(waktu);
  var month = bulan2[tanggal.getMonth()];
  var day = hari[tanggal.getDay()];

  var date = tanggal.getDate().toString();
  if (date.length == 1) {
    date = "0" + date;
  }
  var year = tanggal.getFullYear();
  var jam = tanggal.getHours().toString();

  if (jam.length == 1) {
    jam = "0" + jam;
  }

  var minutes = tanggal.getMinutes().toString();
  if (minutes.length == 1) {
    minutes = "0" + minutes;
  }
  var waktukKu = {};
  waktukKu.tanggalLengkap = date + " " + month + " " + year;
  waktukKu.pukul = jam + ":" + minutes;
  waktukKu.hari = day;
  return waktukKu;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatDate = (waktu) => {
  const hari = {
    0: "Minggu",
    1: "Senin",
    2: "Selasa",
    3: "Rabu",
    4: "Kamis",
    5: "Jumat",
    6: "Sabtu",
  };

  const bulan = {
    0: "Januari",
    1: "Februari",
    2: "Maret",
    3: "April",
    4: "Mei",
    5: "Juni",
    6: "Juli",
    7: "Agustus",
    8: "September",
    9: "Oktober",
    10: "November",
    11: "Desember",
  };

  const bulan2 = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "Mei",
    5: "Jun",
    6: "Jul",
    7: "Agu",
    8: "Sep",
    9: "Okt",
    10: "Nov",
    11: "Des",
  };
  var tanggal = new Date(waktu);
  var month = bulan2[tanggal.getMonth()];

  var date = tanggal.getDate().toString();
  if (date.length == 1) {
    date = "0" + date;
  }
  var year = tanggal.getFullYear();

  const tanggalLengkap = date + " " + month + " " + year;

  return tanggalLengkap;
};

export const formatDateTime = (waktu) => {
  const hari = {
    0: "Minggu",
    1: "Senin",
    2: "Selasa",
    3: "Rabu",
    4: "Kamis",
    5: "Jumat",
    6: "Sabtu",
  };

  const bulan = {
    0: "Januari",
    1: "Februari",
    2: "Maret",
    3: "April",
    4: "Mei",
    5: "Juni",
    6: "Juli",
    7: "Agustus",
    8: "September",
    9: "Oktober",
    10: "November",
    11: "Desember",
  };

  const bulan2 = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "Mei",
    5: "Jun",
    6: "Jul",
    7: "Agu",
    8: "Sep",
    9: "Okt",
    10: "Nov",
    11: "Des",
  };
  var tanggal = new Date(waktu);
  var month = bulan2[tanggal.getMonth()];
  var day = hari[tanggal.getDay()];

  var date = tanggal.getDate().toString();
  if (date.length == 1) {
    date = "0" + date;
  }
  var year = tanggal.getFullYear();
  var jam = tanggal.getHours().toString();

  if (jam.length == 1) {
    jam = "0" + jam;
  }

  var minutes = tanggal.getMinutes().toString();
  if (minutes.length == 1) {
    minutes = "0" + minutes;
  }

  var waktukKu =
    day +
    ", " +
    date +
    " " +
    month +
    " " +
    year +
    " pukul : " +
    jam +
    ":" +
    minutes;

  return waktukKu;
};
export const substractDates = (date) => {
  var now = new Date();
  var tanggal = now.getDate();
  var bulan = now.getMonth() + 1;
  var tahun = now.getFullYear();
  var d1 = new Date(bulan + "/" + tanggal + "/" + tahun);
  var dateKu = new Date(date);
  var days = Math.floor(Math.abs(d1 - dateKu) / 1000 / 60 / 60 / 24);

  var keterangan = "";

  if (days < 1) {
    keterangan = "hari ini";
  } else if (days > 0 && days < 8) {
    keterangan = days + " hari lalu";
  } else {
    var waktu = dateTime(date);
    keterangan = waktu.tanggalLengkap;
  }

  var result = {};
  result.days = days;
  result.keterangan = keterangan;

  return result;
};

export const isValidEmail = (value) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const validateEmail = (value, setEmailError) => {
  if (value == "") {
    setEmailError("");
  } else if (isValidEmail(value)) {
    setEmailError("");
  } else {
    setEmailError("Invalid Email");
  }
};

export const validatePassword = (value, setPasswordError) => {
  if (value.length < 9) {
    setPasswordError("Password must be 9 characters");
  } else {
    setPasswordError("");
  }
};

export const validateNik = (value, setNikError) => {
  if (value.length != 16) {
    setNikError("harus 16 characters");
  } else {
    setNikError("");
  }
};

export const validateStok = (value, setStokError) => {
  if (value.length != 16) {
    setStokError("harus 16 characters");
  } else {
    setStokError("");
  }
};

export const toSmallCaps = (text) => {
  return text.toLowerCase().replace(/(?:^|\s)\S/g, (char) => {
    return char.toUpperCase();
  });
};

export const toProperCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const downloadFile = (url) => {
  // Membuat elemen <a> baru
  const a = document.createElement("a");
  a.href = url;

  // Menentukan nama file yang akan didownload, opsional.
  // Jika Anda tahu nama file atau ingin memberi nama khusus, tambahkan baris berikut:
  // a.download = 'namaFile.doc';

  // Menambahkan elemen ke DOM
  document.body.appendChild(a);

  // Memicu klik untuk memulai proses download
  a.click();

  // Menghapus elemen dari DOM setelah download dimulai
  document.body.removeChild(a);
};

export function hitungtotaljamkerja(resultArray) {
  // Menghitung total waktu kerja dalam menit
  const totalWaktuKerjaMinutes = resultArray.reduce(
    (acc, item) => acc + convertToMinutes(item.waktuKerja),
    0
  );

  // Mengkonversi totalWaktuKerjaMinutes kembali ke format jam:menit
  const totalWaktuKerja = convertFromMinutes(totalWaktuKerjaMinutes);
  return totalWaktuKerja;
}

export function convertToMinutes(timeStr) {
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
}

export function convertFromMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${String(remainingMinutes.toFixed(0)).padStart(2, "0")}`;
}

export function hitungSelisihWaktu(waktuMasuk, waktuPulang) {
  // Mengubah waktu ke objek Date
  if (waktuMasuk !== "" && waktuPulang !== "") {
    const waktuAwal = new Date(`1970-01-01T${waktuMasuk}:00`);
    const waktuAkhir = new Date(`1970-01-01T${waktuPulang}:00`);

    // Menghitung selisih dalam milidetik dan konversi ke menit
    const selisih = (waktuAkhir - waktuAwal) / 1000 / 60;

    // Menghitung jam dan menit
    const jam = Math.floor(selisih / 60);
    const menit = selisih % 60;

    // Mengembalikan waktu dalam format "hh:mm"
    return `${jam.toString().padStart(2, "0")}:${menit
      .toString()
      .padStart(2, "0")}`;
  } else {
    return "00:00";
  }
}

export function leftJoin(A, B, keyA, keyB) {
  const resultArray = A.map((itemA) => {
    let match = B.find((itemB) => itemB[keyB] === itemA[keyA]);

    // Mengambil hari dari tanggal
    const dateObj = new Date(itemA[keyA]);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = WAKTU_KERJA5[dayOfWeek] || "0:00";

    let workingHoursInMinutes = convertToMinutes("0:00");

    if (match && match.status == "Dinas Luar") {
      workingHoursInMinutes = convertToMinutes(waktuKerja);
      match.workingHours = waktuKerja;
    } else if (match && match.waktuMasuk && match.waktuPulang) {
      const wh = hitungSelisihWaktu(match.waktuMasuk, match.waktuPulang);
      match.workingHours = wh;
      workingHoursInMinutes = convertToMinutes(wh);
    } else if (match && !match.workingHours) {
      workingHoursInMinutes = convertToMinutes("0:00");
      match.workingHours = "0:00";
    } else if (!match) {
      match = {};
      match.workingHours = "0:00";
    }

    // Menghitung persentase

    const waktuKerjaInMinutes = convertToMinutes(waktuKerja);
    const persentase = workingHoursInMinutes / waktuKerjaInMinutes;

    return {
      ...itemA,
      ...(match || {}),
      waktuKerja,
      persentase, // Menambahkan properti persentase
    };
  });

  // Menghitung total waktu kerja dalam menit
  const totalWaktuKerjaMinutes = resultArray.reduce(
    (acc, item) => acc + convertToMinutes(item.waktuKerja),
    0
  );

  // Mengkonversi totalWaktuKerjaMinutes kembali ke format jam:menit
  const totalWaktuKerja = convertFromMinutes(totalWaktuKerjaMinutes);

  // Menghitung total workingHours dalam menit
  const totalWorkingMinutes = resultArray.reduce((acc, item) => {
    const [hours, minutes] = item.workingHours.split(":").map(Number);
    return acc + hours * 60 + minutes;
  }, 0);

  // Mengkonversi totalWorkingMinutes kembali ke format jam:menit
  const totalWorkingHours = convertFromMinutes(totalWorkingMinutes);

  return {
    total_waktukerja: totalWaktuKerja,
    total_harikerja: resultArray.length,
    total_workingHours: totalWorkingHours,
    data: resultArray,
  };
}

export const WAKTU_KERJA5 = {
  1: "9:00",
  2: "9:00",
  3: "9:00",
  4: "9:00",
  5: "9:30",
};

export const WAKTU_KERJAShift = {
  pagi: "6:00",
  siang: "6:00",
  malam: "12:00",
};

export const WAKTU_KERJA6 = {
  1: 7,
  2: 7,
  3: 7,
  4: 7,
  5: 4,
  6: 7,
};

export function getDatesWithoutWeekends(startDateStr, endDateStr, libur) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const dates = [];

  while (startDate <= endDate) {
    if (startDate.getDay() !== 0 && startDate.getDay() !== 6) {
      // 0 adalah Minggu dan 6 adalah Sabtu
      dates.push(new Date(startDate)); // Menambahkan tanggal ke list dengan membuat salinan object Date-nya
    }

    startDate.setDate(startDate.getDate() + 1); // Memajukan tanggal ke hari berikutnya
  }

  // Konversi array date menjadi array of objects dengan properti 'tanggal'
  const formattedDates = dates.map((date) => ({
    tanggal: date.toISOString().slice(0, 10),
  }));

  // Membuang tanggal yang sesuai dengan tanggal libur
  const datesWithoutLibur = formattedDates.filter((item) => {
    let liburKu = false;

    libur.map((item2) => {
      if (item.tanggal == item2.tanggal) {
        liburKu = true;
      }
    });
    return liburKu == false;
  });

  const datesKu = datesWithoutLibur.map((item) => {
    const dateObj = new Date(item.tanggal);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = WAKTU_KERJA5[dayOfWeek] || "0:00";

    return { ...item, waktuKerja: waktuKerja };
  });

  return datesKu;
}
